import './gerczaks2/style';
import FormStructure from './gerczaks2/form_structure';

export default FormStructure;